import { Component, input, output } from '@angular/core'

@Component({
    selector: 'vco-icon-button',
    template: `
        <button
            [title]="tooltip()"
            class="icon-button"
            [type]="submit() !== false ? 'submit' : 'button'"
            [disabled]="disabled()"
            (click)="onClick.emit($event)">
            <span class="material-icons-outlined">
                <ng-content></ng-content>
            </span>
        </button>
    `,
    styles: [`
        .icon-button {
            background: none;
            border: none;
            cursor: pointer;
            padding: .25rem;
            display: flex;
            align-items: center;
            color: var(--color-textLight);
            border-radius: 100%;
        }
        .icon-button:hover:not(:disabled) {
            background-color: var(--color-background);
        }
        .icon-button:disabled {
            cursor: default;
            opacity: 0.5;
        }
        .icon-button .material-icons-outlined {
            font-size: 24px;
        }
    `]
}) export class IconButtonComponent {
    readonly disabled = input(false)
    readonly submit = input<'' | boolean>(false)
    readonly tooltip = input('')
    readonly onClick = output<MouseEvent>()
}